<template>
    <section>
        <div class="card-btn likes-btn"
             onclick="return false"  :class="{ 'active' : likeStatus }" v-if="viewMode == 'list-card'">
            <a href="javascript:;" onclick="return false" @click="markLiked($event)">
                <svg v-if="!busy"
                    xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16"><g><g>
                    <path v-if="!likeStatus" d="M16.388 1.696c2.023 2.113 2.19 5.519.227 7.753-1.215 1.381-2.657 2.943-3.976 4.165-.658.61-1.303 1.15-1.886 1.544-.543.367-1.17.703-1.753.703-.584 0-1.21-.336-1.753-.703-.583-.394-1.228-.934-1.886-1.544C4.04 12.392 2.6 10.83 1.385 9.449c-1.964-2.234-1.796-5.64.227-7.753 1.999-2.086 5.18-2.27 7.386-.427L9 1.27l.002-.001c2.207-1.843 5.387-1.66 7.386.427zm-1.08 1.128c-1.448-1.51-3.753-1.643-5.351-.31l-.957.8-.957-.8c-1.598-1.333-3.903-1.2-5.35.31-1.474 1.538-1.564 3.97-.182 5.54 1.202 1.366 2.603 2.88 3.864 4.047.632.584 1.211 1.066 1.701 1.397.529.356.825.446.924.446.1 0 .395-.09.924-.446.49-.331 1.07-.813 1.701-1.397 1.261-1.167 2.662-2.68 3.864-4.048 1.381-1.569 1.292-4-.182-5.539z"/>
                    <path v-else stroke="#000" stroke-width="1.5" fill="#fff" d="M16.388 1.696c2.023 2.113 2.19 5.519.227 7.753-1.215 1.381-2.657 2.943-3.976 4.165-.658.61-1.303 1.15-1.886 1.544-.543.367-1.17.703-1.753.703-.584 0-1.21-.336-1.753-.703-.583-.394-1.228-.934-1.886-1.544C4.04 12.392 2.6 10.83 1.385 9.449c-1.964-2.234-1.796-5.64.227-7.753 1.999-2.086 5.18-2.27 7.386-.427 2.21-1.843 5.391-1.66 7.39.427z"/>
                </g></g></svg>
                <svg v-else class="rotate-infinite"
                     xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15"><g><g><path fill="#8e8e93" d="M2.936 5.288l1.65 1.687a.75.75 0 1 1-1.073 1.05l-.36-.367C3.231 10.913 5.834 13.5 9 13.5a5.763 5.763 0 0 0 4.355-1.995.75.75 0 1 1 1.129.99C13.141 14.025 11.184 15 9 15c-4.025 0-7.27-3.292-7.349-7.35l-.365.375a.75.75 0 0 1-1.072-1.05l1.65-1.687a.757.757 0 0 1 .536-.225c.202 0 .395.082.536.225zM9 1.5a5.763 5.763 0 0 0-4.355 1.995.75.75 0 1 1-1.129-.99C4.859.975 6.816 0 9 0c4.025 0 7.27 3.293 7.349 7.35l.365-.375a.75.75 0 0 1 1.072 1.05l-1.65 1.688a.757.757 0 0 1-.536.225.757.757 0 0 1-.536-.225l-1.65-1.688a.75.75 0 0 1 1.073-1.05l.36.368C14.769 4.088 12.166 1.5 9 1.5z"/></g></g>
                </svg>
            </a>
            <span onclick="return false" @click="markLiked($event)">Like</span>
        </div>

        <a href="javascript:;" @click="markLiked()" v-if="viewMode == 'user-card'">
            <svg class="rotate-infinite" v-if="busy"
                 xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15"><g><g><path fill="#8e8e93" d="M2.936 5.288l1.65 1.687a.75.75 0 1 1-1.073 1.05l-.36-.367C3.231 10.913 5.834 13.5 9 13.5a5.763 5.763 0 0 0 4.355-1.995.75.75 0 1 1 1.129.99C13.141 14.025 11.184 15 9 15c-4.025 0-7.27-3.292-7.349-7.35l-.365.375a.75.75 0 0 1-1.072-1.05l1.65-1.687a.757.757 0 0 1 .536-.225c.202 0 .395.082.536.225zM9 1.5a5.763 5.763 0 0 0-4.355 1.995.75.75 0 1 1-1.129-.99C4.859.975 6.816 0 9 0c4.025 0 7.27 3.293 7.349 7.35l.365-.375a.75.75 0 0 1 1.072 1.05l-1.65 1.688a.757.757 0 0 1-.536.225.757.757 0 0 1-.536-.225l-1.65-1.688a.75.75 0 0 1 1.073-1.05l.36.368C14.769 4.088 12.166 1.5 9 1.5z"/></g></g></svg>
            <span class="like-btn" :class="{ 'active' : likeStatus}" v-else>
                <svg
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="-1 -2 20 19"><g><g><g><path fill="#FF3B30" d="M16.388 1.696c2.023 2.113 2.19 5.519.227 7.753-1.215 1.381-2.657 2.943-3.976 4.165-.658.61-1.303 1.15-1.886 1.544-.543.367-1.17.703-1.753.703-.584 0-1.21-.336-1.753-.703-.583-.394-1.228-.934-1.886-1.544C4.04 12.392 2.6 10.83 1.385 9.449c-1.964-2.234-1.796-5.64.227-7.753 1.999-2.086 5.18-2.27 7.386-.427 2.21-1.843 5.391-1.66 7.39.427z"></path></g></g></g></svg>
            </span>
        </a>

        <div class="documents-like-icon"
             :class="{ 'active' : likeStatus, 't35' : t35}" v-if="viewMode == 'doc-view'">
            <a href="javascript:;" @click="markLiked($event)" >
                <svg v-if="!busy"
                     xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="-1 -2 20 19"><g><g><g>
                    <path fill="#ff3b30" d="M16.388 1.696c2.023 2.113 2.19 5.519.227 7.753-1.215 1.381-2.657 2.943-3.976 4.165-.658.61-1.303 1.15-1.886 1.544-.543.367-1.17.703-1.753.703-.584 0-1.21-.336-1.753-.703-.583-.394-1.228-.934-1.886-1.544C4.04 12.392 2.6 10.83 1.385 9.449c-1.964-2.234-1.796-5.64.227-7.753 1.999-2.086 5.18-2.27 7.386-.427 2.21-1.843 5.391-1.66 7.39.427z"/></g></g></g>
                </svg>
                <svg v-else class="rotate-infinite"
                      xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15"><g><g><path fill="#8e8e93" d="M2.936 5.288l1.65 1.687a.75.75 0 1 1-1.073 1.05l-.36-.367C3.231 10.913 5.834 13.5 9 13.5a5.763 5.763 0 0 0 4.355-1.995.75.75 0 1 1 1.129.99C13.141 14.025 11.184 15 9 15c-4.025 0-7.27-3.292-7.349-7.35l-.365.375a.75.75 0 0 1-1.072-1.05l1.65-1.687a.757.757 0 0 1 .536-.225c.202 0 .395.082.536.225zM9 1.5a5.763 5.763 0 0 0-4.355 1.995.75.75 0 1 1-1.129-.99C4.859.975 6.816 0 9 0c4.025 0 7.27 3.293 7.349 7.35l.365-.375a.75.75 0 0 1 1.072 1.05l-1.65 1.688a.757.757 0 0 1-.536.225.757.757 0 0 1-.536-.225l-1.65-1.688a.75.75 0 0 1 1.073-1.05l.36.368C14.769 4.088 12.166 1.5 9 1.5z"/></g></g>
                </svg>
            </a>
        </div>


    </section>

</template>

<script>
import ApiService from "../../api/api.service";

export default {
    name: "LikeButton",
    data: () => {
        return {
            likeStatus: null,
            busy: false,
            totalLikes: 0,

        };
    },
    props: ['docId', 'viewMode', 'status', 'total_likes', 'index', 't35'],
    mounted() {
        if(this.viewMode != 'list-card') {
            this.likedByMe();
        } else {
            this.likeStatus = this.status;
            this.totalLikes = this.total_likes;
        }
    },
    methods: {

        likedByMe() {
            ApiService.setHeader();
            ApiService.get('/api/document/liked/' + this.docId)
                .then(({data}) => {
                    this.likeStatus = data.data;
                    this.totalLikes = data.total;
                })
                .catch((res) => {
                    console.log(res)
                });
        },
        markLiked($event) {
            this.busy = true;

            this.$parent.clickedApp = true;
            // reverting back
            setTimeout(() => {
              this.$parent.clickedApp = false;
            } , 300);

            let newStatus;

            if($event) {
                newStatus = $event.target.checked
            } else {
                newStatus = !this.likeStatus
            }
            // already marked
            let likeData = {
                document_id: this.docId,
                status: newStatus
            } ;

            ApiService.setHeader();
            ApiService.post('/api/likes', likeData)
                .then(({data}) => {
                    this.likeStatus = data.data;
                    if(this.likeStatus) {
                        this.totalLikes = this.totalLikes + 1;
                    } else {
                        this.totalLikes = this.totalLikes - 1;
                    }
                    if(this.viewMode != 'list-card') {
                        this.$parent.totalLikes = this.totalLikes;
                    } else {
                        let selector = document.getElementById("likesCount" + this.index);
                        let icon = document.getElementById("card-like-icon" + this.index);
                        let value = selector.innerHTML
                        if(this.likeStatus) {
                            selector.innerHTML = Number(value) + 1;
                            icon.classList.add('active');
                        } else {
                            selector.innerHTML = Number(value) - 1;
                            icon.classList.remove('active');
                        }
                    }



                    this.busy = false;
                })
                .catch((res) => {
                    console.log(res)
                    this.busy = false;
                });

            //


        }
    }
}
</script>

<style scoped>

.t35 {
    top: 35px !important;
}
</style>
